export class Api {
  constructor({ baseUrl }) {
    this._baseUrl = baseUrl;
  }

  _checkError(res) {
    if (res.ok) {
      return res.json();
    }
    return Promise.reject(`Ошибка: ${res.status}`);
  }

  getAuthors() {
    return fetch(`${this._baseUrl}/authors`, {
      method: "GET",
    }).then(this._checkError);
  }

  getPublications() {
    return fetch(`${this._baseUrl}/posts`, {
      method: "GET",
    }).then(this._checkError);
  }
}

export const api = new Api({
  baseUrl: "https://reya.media/wp-json/myplugin/v1",
});
